<button class="cen-button" [disabled]="disabled" [type]="type" (click)="btnClick.emit($event)">
    <!-- <ng-template [ngTemplateOutlet]="labelButton?.templateRef"></ng-template>{{label}} -->
    <span *ngIf="text">
        {{text}}
    </span>
    <span *ngIf="!text">
        <ng-content></ng-content>
    </span>
</button>